<style lang="stylus">
    .storage-box
        position absolute
        right 16px
        bottom 32px
        min-width 188px
        padding 12px
        border-radius 8px
        background #fff
        box-shadow 0px 2px 12px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 0px rgba(0, 0, 0, 0.05)
        user-select none
        z-index 10
        &.storage-vip
            width 210px
        .vip-btn
            display flex
            justify-content center
            align-items center
            position relative
            width 100%
            height 24px
            margin-bottom 12px
            cursor pointer
            background linear-gradient(98deg, #FFEDD1 0%, #FFCF88 100%)
            img
                display block
                position absolute
                right 0
                bottom 0
                pointer-events none
            p
                font-size 12px
                line-height 16px
                color #632400
                z-index 1
                user-select none
        .storage-text
            display flex
            justify-content space-between
            margin-bottom 6px
            .storage-title
                margin-right 4px
            .storage-num
                text-align right
            p
                font-size 12px
                color #222
                line-height 16px
                flex-shrink 0
                textOverflow()
                .storage-blue
                    color #017fff
        .storage-bar
            position relative
            width 100%
            height 4px
            border-radius 100px
            background #F2F4F9
            .storage-use
                position absolute
                left 0
                top 0
                height 100%
                background #017fff
                max-width 100%
                border-radius 100px
                &.warn-bar
                    background #FD6969
    .dark-theme_pcview--storage
        background #2A2C2E
        box-shadow 0px 2px 12px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 0px rgba(0, 0, 0, 0.10)
        .storage-text
            p
                color #E6E6E6
        .storage-bar
            background rgba(255, 255, 255, 0.12)
</style>

<template>
    <div class="storage-box" :class="{ 'storage-vip': vip, 'dark-theme_pcview--storage': isPCDarkMode == 2 }">
        <div class="vip-btn" v-if="!vip" @click="tobuy">
            <img src="@/home/assets/pcview/storage-icon.svg" alt="" />
            <p>{{ $t("moreStorage") }}</p>
        </div>

        <div class="storage-text">
            <p class="storage-title">{{ $t("cloudStorage") }}</p>
            <p class="storage-num">
                <span class="storage-blue">{{ formatNum(used) }}</span>
                /
                <span>{{ formatNum(max, 0) }}</span>
            </p>
        </div>

        <div class="storage-bar">
            <div class="storage-use" :class="{ 'warn-bar': warn }" :style="{ width: `${(used / max) * 100}%` }"></div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class Storage extends Vue {
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get used() {
            return this.userInfo.used_storage;
        }
        get max() {
            return this.userInfo.max_storage;
        }
        get warn() {
            return this.used / this.max > 0.8;
        }
        tobuy() {
            this.$openBuyPage("cloudSpaceLeftBottom");
        }
        formatNum(num, decimal = 2) {
            num = num || 0;
            if (num > 1024 * 1024 * 1024) {
                return `${(num / 1024 / 1024 / 1024).toFixed(decimal)}G`;
            } else if (num > 1024 * 1024) {
                return `${(num / 1024 / 1024).toFixed(decimal)}M`;
            } else {
                return `${(num / 1024).toFixed(decimal)}K`;
            }
        }
        refreshStorage() {
            this.$store.dispatch("getUserInfo");
        }
        created() {
            this.$bus.$on("refreshEv", this.refreshStorage);
        }
        mounted() {}

        beforeDestroy() {
            this.$bus.$off("refreshEv", this.refreshStorage);
        }
    }
</script>
<i18n>
{
    "zh": {
        "cloudStorage": "云空间",
        "moreStorage": "开通VIP 获取云空间"
    },
    "en": {
        "cloudStorage": "Used Space",
        "moreStorage": "Upgrade for More Space"
    },
    "fr": {
        "cloudStorage": "Espace utilisé",
        "moreStorage": "Plus d'espace"
    },
    "de": {
        "cloudStorage": "Belegter Speicher",
        "moreStorage": "Mehr Platz"
    },
    "jp": {
        "cloudStorage": "使用済み領域",
        "moreStorage": "領域を追加する"
    },
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
